module.exports = __webpack_public_path__ + "static/media/search_fff.e3f5fdea.svg";